import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { contextConnect, useContextSystem } from '@wp-g2/context';
import { css, cx } from '@wp-g2/styles';
import React from 'react';
import { AspectRatio } from '../AspectRatio';
import { ImageView } from './Image.styles';

function Image(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'Image'),
      aspectRatio = _useContextSystem.aspectRatio,
      className = _useContextSystem.className,
      fit = _useContextSystem.fit,
      height = _useContextSystem.height,
      width = _useContextSystem.width,
      otherProps = _objectWithoutProperties(_useContextSystem, ["aspectRatio", "className", "fit", "height", "width"]);

  var sx = {};
  var aspectFit = aspectRatio && !fit ? 'cover' : fit;
  var preferredFit = aspectRatio ? aspectFit : fit;
  sx.base = css({
    width: width,
    height: height
  });
  sx.fit = css({
    objectFit: preferredFit
  });
  sx.fitSize = css({
    height: '100%',
    width: '100%'
  });
  var classes = cx(sx.base, sx.fit, fit && sx.fitSize, className);

  var imageProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    className: classes,
    height: height,
    width: width,
    ref: forwardedRef
  });

  if (aspectRatio) {
    return /*#__PURE__*/React.createElement(AspectRatio, {
      ratio: aspectRatio,
      width: width
    }, /*#__PURE__*/React.createElement(ImageView, imageProps));
  }

  return /*#__PURE__*/React.createElement(ImageView, imageProps);
}

export default contextConnect(Image, 'Image');